import { MapSection } from "components/map_section";
import { TwoColumnSection } from "components/two_column_section";
import { FormContentSection } from "components/form_content_section";
import { ViewMapFormScetion } from "components/view_map_form_scetion";
import { DataInsightFormSection } from "components/data_insight_section";
import { useState } from "react";
import { Nav } from "react-bootstrap";

export const HomePage = () => {
  const [formState, setFormState] = useState("federal");
  const formTabs = [
    {
      title: "Federal",
      value: "federal",
    },
    {
      title: "States",
      value: "states",
    },
  ];

  const handleSubmit = (formData) => {
    console.log("formData", formData);
  };

  return (
    <TwoColumnSection
      firstColumn={
        <FormContentSection title="Please Fil the form to get dataset">
          <Nav
            variant="pills"
            defaultActiveKey={formState}
            className="bg-white shadow rounded-3 mb-5 "
          >
            {formTabs.map((tab, index) => (
              <Nav.Item className="col-6 text-center" key={index}>
                <Nav.Link
                  eventKey={tab.value}
                  color="secondary"
                  onClick={() => setFormState(tab.value)}
                >
                  {tab.title}
                </Nav.Link>
              </Nav.Item>
            ))}
          </Nav>

          {formState === "federal" ? (
            <ViewMapFormScetion handleSubmit={handleSubmit} />
          ) : formState === "states" ? (
            <ViewMapFormScetion handleSubmit={handleSubmit} />
          ) : (
            <></>
          )}

          <DataInsightFormSection />
        </FormContentSection>
      }
      secondColumn={
        <MapSection
          mapCordiantes={[51.505, -0.09]}
          markerList={[
            {
              latitude: 51.5,
              longitude: -0.09,
              name: "Marker Name 1",
              fulladdress: "Address of the marker",
            },
            {
              latitude: 51.51,
              longitude: -0.1,
              name: "Marker Name 2",
              fulladdress: "Address of the marker 2",
            },
            {
              latitude: 51.55,
              longitude: -0.05,
              name: "Marker Name 3",
              fulladdress: "Address of the marker 3",
            },
          ]}
        />
      }
    />
  );
};
